import React, { useState, useEffect } from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function PublicCheckout() {
  const brand = useSiteSettings();
  const { id, token } = useParams();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [payMethod, setPayMethod] = useState('credit_card'); // 'credit_card' | 'bank_transfer'
  
  // Card details
  const [cardName, setCardName] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [cardExpiry, setCardExpiry] = useState('');
  const [cardCvv, setCardCvv] = useState('');
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    fetchPaymentDetails();
  }, [id, token]);

  const fetchPaymentDetails = async () => {
    try {
      const res = await axios.get(`/api/public/payments/${id}/${token}`);
      setPayment(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Ödeme detayları alınamadı. Bağlantı geçersiz veya süresi dolmuş olabilir.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    try {
      await axios.post(`/api/public/payments/${id}/${token}`, { method: payMethod });
      setSuccess(true);
    } catch (err) {
      alert(err.response?.data?.error || 'Ödeme işlemi sırasında bir hata oluştu.');
    } finally {
      setProcessing(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#09090e' }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#09090e', padding: '20px' }}>
        <div style={{ background: 'rgba(244, 63, 94, 0.08)', border: '1px solid rgba(244, 63, 94, 0.2)', padding: '32px', borderRadius: '20px', maxWidth: '480px', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '8px' }}>Ödeme Bağlantısı Hatası</h2>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', lineHeight: '1.6' }}>{error}</p>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#09090e', padding: '20px' }}>
        <div style={{ background: 'rgba(16, 185, 129, 0.08)', border: '1px solid rgba(16, 185, 129, 0.2)', padding: '40px 32px', borderRadius: '24px', maxWidth: '480px', textAlign: 'center', width: '100%' }}>
          <div style={{ fontSize: '64px', marginBottom: '16px', animation: 'scaleUp .4s ease-out' }}>✅</div>
          <h2 style={{ color: '#fff', fontSize: '1.5rem', marginBottom: '12px', fontWeight: 800 }}>Ödeme Başarılı</h2>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', lineHeight: '1.6', marginBottom: '24px' }}>
            Teşekkürler! <strong>₺{Number(payment.net_amount).toLocaleString('tr-TR')}</strong> tutarındaki ödemeniz güvenle tahsil edilmiştir.
          </p>
          <div style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '12px', padding: '16px', fontSize: '12px', color: 'var(--text-muted)', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
              <span>Ödeyen:</span>
              <span style={{ color: '#fff', fontWeight: 600 }}>{payment.first_name} {payment.last_name}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>İşlem Tarihi:</span>
              <span style={{ color: '#fff', fontWeight: 600 }}>{new Date().toLocaleDateString('tr-TR')}</span>
            </div>
          </div>
        </div>
        <style>{`
          @keyframes scaleUp { 0% { transform: scale(0.8); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
        `}</style>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#09090e', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px' }}>
      <div style={{ width: '100%', maxWidth: '480px', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 24px 64px rgba(0,0,0,0.6)', backdropFilter: 'blur(20px)' }}>
        {/* Header */}
        <div style={{ padding: '24px', background: 'linear-gradient(135deg, rgba(var(--primary-rgb), 0.1) 0%, rgba(var(--secondary-rgb), 0.1) 100%)', borderBottom: '1px solid rgba(255,255,255,0.05)', textAlign: 'center' }}>
          <h2 style={{ color: '#fff', fontSize: '1.25rem', fontWeight: 800, margin: 0 }}>Kolay ve Güvenli Ödeme</h2>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', marginTop: '4px', margin: 0 }}>{brand.site_name} Güvenli Ödeme Geçidi</p>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: '24px' }}>
          {/* Amount Box */}
          <div style={{ background: 'rgba(var(--primary-rgb), 0.04)', border: '1px solid rgba(var(--primary-rgb), 0.15)', borderRadius: '16px', padding: '16px', textAlign: 'center', marginBottom: '24px' }}>
            <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', display: 'block', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Ödenecek Tutar</span>
            <span style={{ fontSize: '28px', fontWeight: 800, color: 'var(--primary)', display: 'block', margin: '4px 0' }}>
              ₺{Number(payment.net_amount).toLocaleString('tr-TR')}
            </span>
            <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)' }}>{payment.first_name} {payment.last_name}</span>
          </div>

          {/* Payment Method Select */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: '8px' }}>Ödeme Yöntemi</label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div 
                onClick={() => setPayMethod('credit_card')}
                style={{
                  background: payMethod === 'credit_card' ? 'rgba(0, 242, 254, 0.08)' : 'rgba(255,255,255,0.01)',
                  border: payMethod === 'credit_card' ? '1px solid var(--primary)' : '1px solid rgba(255,255,255,0.06)',
                  borderRadius: '12px', padding: '12px', textAlign: 'center', cursor: 'pointer', fontWeight: 600, color: '#fff', fontSize: '13px', transition: 'all .2s'
                }}
              >
                💳 Kredi Kartı
              </div>
              <div 
                onClick={() => setPayMethod('bank_transfer')}
                style={{
                  background: payMethod === 'bank_transfer' ? 'rgba(0, 242, 254, 0.08)' : 'rgba(255,255,255,0.01)',
                  border: payMethod === 'bank_transfer' ? '1px solid var(--primary)' : '1px solid rgba(255,255,255,0.06)',
                  borderRadius: '12px', padding: '12px', textAlign: 'center', cursor: 'pointer', fontWeight: 600, color: '#fff', fontSize: '13px', transition: 'all .2s'
                }}
              >
                🏦 Havale / EFT
              </div>
            </div>
          </div>

          {payMethod === 'credit_card' ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '24px' }}>
              {/* Card Holder */}
              <div>
                <label style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: '6px' }}>Kart Üzerindeki İsim</label>
                <input 
                  type="text" 
                  className="input" 
                  value={cardName}
                  onChange={e => setCardName(e.target.value)}
                  placeholder="John Doe"
                  required
                />
              </div>

              {/* Card Number */}
              <div>
                <label style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: '6px' }}>Kart Numarası</label>
                <input 
                  type="text" 
                  className="input" 
                  value={cardNumber}
                  onChange={e => setCardNumber(e.target.value)}
                  placeholder="0000 0000 0000 0000"
                  required
                />
              </div>

              {/* Expiry & CVV */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: '6px' }}>Son Kullanma</label>
                  <input 
                    type="text" 
                    className="input" 
                    value={cardExpiry}
                    onChange={e => setCardExpiry(e.target.value)}
                    placeholder="AA/YY"
                    required
                  />
                </div>
                <div>
                  <label style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: '6px' }}>CVC / CVV</label>
                  <input 
                    type="password" 
                    className="input" 
                    value={cardCvv}
                    onChange={e => setCardCvv(e.target.value)}
                    placeholder="***"
                    maxLength="3"
                    required
                  />
                </div>
              </div>
            </div>
          ) : (
            <div style={{ background: 'rgba(255,255,255,0.01)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '14px', padding: '16px', marginBottom: '24px', fontSize: '13px', lineHeight: '1.6' }}>
              <strong style={{ color: '#fff', display: 'block', marginBottom: '6px' }}>Banka Hesap Bilgileri:</strong>
              <div style={{ color: 'rgba(255,255,255,0.6)' }}>
                <div><strong>Banka:</strong> Garanti BBVA</div>
                <div><strong>Alıcı:</strong> Ritsa CRM Ltd. Şti.</div>
                <div><strong>IBAN:</strong> TR90 0006 2000 0001 2345 6789 01</div>
                <div style={{ marginTop: '8px', fontSize: '11px', color: 'var(--primary)' }}>* Lütfen açıklama kısmına isminizi yazınız.</div>
              </div>
            </div>
          )}

          {/* Submit Button */}
          <button 
            type="submit" 
            className="btn btn-primary" 
            disabled={processing}
            style={{ width: '100%', padding: '14px', borderRadius: '12px', fontWeight: 700 }}
          >
            {processing ? '⌛ İşleniyor...' : `₺${Number(payment.net_amount).toLocaleString('tr-TR')} Öde`}
          </button>
        </form>
      </div>
    </div>
  );
}

export default PublicCheckout;
